"use client";

import DynamicExpandableSection from "@/components/DynamicExpandableSection";

export default function CountryDynamicTextClient({ title, text }) {
  return (
    <DynamicExpandableSection
      title={title}
      text={text}
      showTurnaLogo={false}
      sectionClassName="bg-background-global"
      contentClassName=" container relative overflow-hidden rounded-lg py-6 md:py-8"
    />
  );
}
